import { useEffect, useState } from "react";
import api, { admin } from "../services/api";

const AdminVerifyClaims = () => {
  const [claims, setClaims] = useState([]);
  const [flaggedIssues, setFlaggedIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [claimsRes, flaggedRes] = await Promise.all([
          admin.getClaims("pending"),
          api.get("/admin/flagged-issues"),
        ]);
        setClaims(Array.isArray(claimsRes.data) ? claimsRes.data : []);
        setFlaggedIssues(Array.isArray(flaggedRes.data) ? flaggedRes.data : []);
      } catch (err) {
        console.error("Error fetching admin data", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDecision = async (claimId, action) => {
    try {
      const payload =
        action === "reject"
          ? { reason: window.prompt("Enter rejection reason:") || "Claim rejected by admin" }
          : undefined;
      if (action === "approve") {
        await admin.approveClaim(claimId);
      } else {
        await admin.rejectClaim(claimId, payload);
      }
      setClaims((prev) => prev.filter((claim) => claim._id !== claimId));
    } catch (err) {
      console.error("Error updating claim", err);
    }
  };

  const handleFlaggedIssueAction = async (issueId, action) => {
    try {
      await api.patch(`/admin/flagged-issues/${issueId}/${action}`);
      setFlaggedIssues((prev) => prev.filter((issue) => issue._id !== issueId));
    } catch (err) {
      console.error("Error updating flagged issue", err);
    }
  };

  if (loading) return <div className="py-10 text-center">Loading admin data...</div>;

  return (
    <div className="mx-auto max-w-6xl space-y-12 px-4 py-12">
      <div>
        <h1 className="mb-8 text-center text-3xl font-bold text-blue-700">Admin: Verify Candidate Claims</h1>
        {claims.length === 0 ? (
          <p className="text-center text-gray-500">No pending claims.</p>
        ) : (
          <ul className="space-y-6">
            {claims.map((claim) => (
              <li key={claim._id} className="rounded border bg-white p-6 shadow">
                <h2 className="mb-2 text-xl font-semibold text-gray-800">
                  {claim.fullName || "Unknown"} ({claim.position || "N/A"})
                </h2>
                <p className="mb-1 text-sm text-gray-600">Party: <span className="font-medium">{claim.party || "N/A"}</span></p>
                <p className="mb-1 text-sm text-gray-600">
                  State: {claim.state || "N/A"} | Constituency: {claim.constituency || "N/A"}
                </p>
                <p className="mb-1 text-sm text-gray-600">
                  Phone: {claim.phone || "N/A"} | Email: {claim.email || "N/A"}
                </p>
                <p className="text-sm text-gray-500">Aadhaar (Last 4): {claim.aadhaarLast4 || "N/A"}</p>

                <div className="mt-4 flex gap-4">
                  <button
                    onClick={() => handleDecision(claim._id, "approve")}
                    className="rounded bg-green-600 px-4 py-2 text-white shadow hover:bg-green-700"
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleDecision(claim._id, "reject")}
                    className="rounded bg-red-600 px-4 py-2 text-white shadow hover:bg-red-700"
                  >
                    Reject
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div>
        <h2 className="mb-4 text-center text-2xl font-bold text-red-600">Review AI-Flagged Issues</h2>
        {flaggedIssues.length === 0 ? (
          <p className="text-center text-gray-500">No flagged issues by AI.</p>
        ) : (
          <ul className="space-y-6">
            {flaggedIssues.map((issue) => (
              <li key={issue._id} className="rounded border-l-4 border-red-600 bg-white p-6 shadow">
                <h3 className="mb-1 text-xl font-semibold text-gray-800">{issue.title || "Untitled issue"}</h3>
                <p className="mb-2 text-sm text-gray-600">{issue.description || "No description provided."}</p>
                <p className="text-sm text-gray-500">
                  <strong>{issue.moderationLabel || "Unlabeled"}</strong> - {issue.flaggedReason || "No reason provided"}
                </p>
                <p className="text-xs text-gray-400">
                  {issue.createdAt ? new Date(issue.createdAt).toLocaleString() : "Date unavailable"}
                </p>

                <div className="mt-4 flex gap-4">
                  <button
                    onClick={() => handleFlaggedIssueAction(issue._id, "approve")}
                    className="rounded bg-green-600 px-4 py-2 text-white shadow hover:bg-green-700"
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleFlaggedIssueAction(issue._id, "ignore")}
                    className="rounded bg-gray-500 px-4 py-2 text-white shadow hover:bg-gray-600"
                  >
                    Ignore
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminVerifyClaims;
